import React from 'react';
import {connect} from 'react-redux';
import { CommandBar } from '@fluentui/react';
import TranslateTag from '../../../Utils/Local/TranslateTag';

const TopbarMenu = (props) => {

    const items = props.buttons.map((button) => {

        let returnButtonList = { id: button.key, key: button.key, text: button.text, iconProps: { iconName: button.icon }, onClick: () => props.clickButton(button) };

        if (button.buttons !== undefined && button.buttons !== "") {
            const subMenus = button.buttons.map((subMenuButton) => {
                return { 
                    key: subMenuButton.key,
                    text: subMenuButton.text,
                    iconProps: { iconName: subMenuButton.icon },
                    onClick: () => props.clickButton(subMenuButton)
                }
            })
            returnButtonList.subMenuProps = { items: subMenus};
        }
        return returnButtonList;
    });

    const farItems = [];
    if (props.suppressFarItems !== true) {
        // if (props.showReportIcon) {
        //     farItems.push({ id: "reportButton", key: 'report', text: TranslateTag("Test", props.language), ariaLabel: 'Show Report', iconOnly: true, iconProps: { iconName: 'PDF' }, onClick: () => props.onPdfClick() });
        // }
        if (props.showFilterIcon) {
            farItems.push({ id: "filterButton", key: 'filter', text: TranslateTag("@GenFil@", props.language), ariaLabel: 'Toggle Filter', iconOnly: true, iconProps: { iconName: 'Filter' }, onClick: () => props.onFilterClick() });
        }
        if (props.showCardIcon) {
            const cardMenuItem = { id: "gridButton", key: 'tile', text: TranslateTag("@GenGri@", props.language), ariaLabel: 'Grid view', iconOnly: true, iconProps: { iconName: 'Tiles' }, onClick: () => props.onListTypeClick()};
            if (props.listType === "card") {
                cardMenuItem.iconProps = { iconName: 'Table' };
                cardMenuItem.ariaLabel = "Table View";
                cardMenuItem.text = TranslateTag("@GenTra@", props.language)
            }
            farItems.push(cardMenuItem);
        }
        farItems.push({ id: "fullscreen", key: 'fullscreen', text: (props.showFullScreen) ? TranslateTag("@GenExiA@", props.language) : TranslateTag("@GenEnt@", props.language), ariaLabel: TranslateTag("@GenExiA", props.language), 
                        iconOnly: true, iconProps: { iconName: (props.showFullScreen) ? 'BackToWindow' : 'FullScreen'}, onClick: () => props.onFullScreenClick() });

        if (! props.displayGridView) {
            farItems.splice(1,1);
        }
    }

    return (
        <div>
            <CommandBar
                items={items}
                styles={{
                    root: { margin: '0% 0% 0% 1%', border: '0px', padding: '0px' }
                }}
                farItems={farItems}
            />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        showFullScreen: state.display.showFullScreen
    };
}

export default connect(mapStateToProps)(TopbarMenu);
